import React, { useState } from "react";
import { footer, brand, contact } from "../../mock/mock";

const RESET_DELAY_MS = 4000;

const NewsletterBar = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    const subject = encodeURIComponent("Newsletter Subscription");
    const body = encodeURIComponent(
      `Please add me to the Overdressed Couture list for news and updates.\n\nEmail: ${email}`
    );
    window.location.href = `mailto:${contact.email}?subject=${subject}&body=${body}`;
    setSubmitted(true);
    setEmail("");
    setTimeout(() => setSubmitted(false), RESET_DELAY_MS);
  };

  return (
    <div className="border-b border-white/10">
      <div className="max-w-[1300px] mx-auto px-5 md:px-8 py-16 md:py-20 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="text-center lg:text-left">
          <h2 className="font-display text-2xl md:text-4xl mb-2">
            Join the List
          </h2>
          <p className="font-body text-white/60 text-sm">
            Early access to drops, live shows & VIP offers.
          </p>
        </div>
        <form
          onSubmit={handleSubmit}
          className="flex items-center w-full max-w-md bg-white rounded-full p-1.5"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 bg-transparent outline-none font-body text-sm text-[#1A1A1A] placeholder:text-[#999] px-5"
          />
          <button
            type="submit"
            className="bg-[#822432] text-white font-body text-xs font-semibold uppercase tracking-wide-sm px-6 py-3 rounded-full hover:bg-[#6a1c28] transition-colors"
          >
            {submitted ? "Joined!" : "Subscribe"}
          </button>
        </form>
      </div>
    </div>
  );
};

const FooterLinks = () => (
  <>
    <div className="col-span-2 md:col-span-1">
      <div className="inline-block bg-white rounded-xl px-5 py-4 mb-4">
        <img
          src={brand.logo}
          alt="Overdressed Couture"
          className="h-20 w-auto object-contain"
        />
      </div>
      <p className="font-body text-sm text-white/50 leading-relaxed">
        {brand.tagline}
      </p>
    </div>
    {footer.columns.map((col) => (
      <div key={col.title}>
        <h4 className="font-body text-[11px] font-semibold tracking-wide-sm uppercase text-[#C8102E] mb-5">
          {col.title}
        </h4>
        <ul className="space-y-3">
          {col.links.map((link) => (
            <li key={link}>
              <a
                href="#"
                className="font-body text-sm text-white/70 hover:text-white transition-colors"
              >
                {link}
              </a>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </>
);

const FooterBottom = () => (
  <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
    <p className="font-body text-xs text-white/40">
      © 2025 Overdressed Couture. All rights reserved.
    </p>
    <div className="flex items-center gap-6">
      {footer.social.map((s) => (
        <a
          key={s.label}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-body text-xs font-medium text-white/60 hover:text-[#C8102E] transition-colors"
        >
          {s.label}
        </a>
      ))}
    </div>
  </div>
);

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      <NewsletterBar />
      <div className="max-w-[1300px] mx-auto px-5 md:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <FooterLinks />
        </div>
        <FooterBottom />
      </div>
    </footer>
  );
};

export default Footer;
